import React, { useState, useEffect } from 'react';
import { getCompanies } from '../api';

const API_URL = process.env.REACT_APP_API_URL || 'https://stock-api-production-913a.up.railway.app';

const clr = v => v == null ? '#aaa' : v > 0 ? '#d62828' : v < 0 ? '#00a14b' : '#aaa';
// [RETAIL_CLR_V1] 散戶人數專用反向配色：人數增加(籌碼分散)顯示綠色，人數減少(籌碼集中)顯示紅色
const clrRev = v => v == null ? '#aaa' : v > 0 ? '#00a14b' : v < 0 ? '#d62828' : '#aaa';
const fmt  = (v, dec=2) => v == null ? '-' : v.toFixed(dec) + '%';
const fmtN = v => v == null ? '-' : (v > 0 ? '+' : '') + v.toLocaleString();

export default function Portfolio({ setTicker, watchlist = [], addToWatchlist, removeFromWatchlist }) {
  // 手機偵測
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  // 表格樣式(手機縮 padding)
  const th = { padding: isMobile ? '6px 6px' : '8px 10px', textAlign:'right', fontWeight:600, borderBottom:'1px solid #2a3a4a', color:'#ddd', whiteSpace:'nowrap', background:'#0d1520', fontSize: isMobile ? 11 : 12, position:'sticky', top:0, zIndex:10 };
  const td = { padding: isMobile ? '5px 6px' : '7px 10px', textAlign:'right', borderBottom:'1px solid #1e2a3a', whiteSpace:'nowrap', fontSize: isMobile ? 11 : 12 };
  const thS = { ...th, textAlign:'left', position:'sticky', top:0, left:0, zIndex:20, background:'#0d1520', minWidth: isMobile ? 80 : 110 };
  const tdS = { ...td, textAlign:'left', position:'sticky', left:0, zIndex:1, fontWeight:600 };
  const [companies, setCompanies] = useState([]);
  const [search, setSearch]       = useState('');
  const [results, setResults]     = useState([]);
  const [summary, setSummary]     = useState([]);
  const [loading, setLoading]     = useState(false);

  useEffect(() => { getCompanies().then(setCompanies); }, []);

  useEffect(() => {
    if (!search) { setResults([]); return; }
    const q = search.toLowerCase();
    setResults(companies.filter(c =>
      c.ticker.toLowerCase().includes(q) || c.name.toLowerCase().includes(q)
    ).slice(0, 6));
  }, [search, companies]);

  useEffect(() => {
    if (watchlist.length === 0) { setSummary([]); return; }
    setLoading(true);
    const tickers = watchlist.map(w => w.ticker).join(',');
    fetch(`${API_URL}/api/watchlist/summary?tickers=${tickers}`)
      .then(r => r.json())
      .then(d => { setSummary(Array.isArray(d) ? d : []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [watchlist]);

  const handleAdd = (ticker, name) => {
    addToWatchlist && addToWatchlist(ticker, name);
    setSearch(''); setResults([]);
  };

  const summaryMap = Object.fromEntries(summary.map(s => [s.ticker, s]));

  return (
    <div style={{ padding: isMobile ? 4 : 8 }}>
      <h2 style={{ marginBottom: isMobile ? 10 : 12, fontSize: isMobile ? 18 : 22, fontWeight: 700 }}>⭐ 私房股</h2>

      {/* 搜尋加入 */}
      <div style={{ marginBottom: isMobile ? 12 : 16, background:'#0d1520', border:'1px solid #1e2a3a', borderRadius:8, padding: isMobile ? 10 : 16 }}>
        <div style={{ color:'#7ab0cc', fontSize:13, marginBottom:8, fontWeight:600 }}>🔍 搜尋加入個股</div>
        <div style={{ position:'relative', maxWidth: isMobile ? '100%' : 360 }}>
          <input value={search} onChange={e => setSearch(e.target.value)}
            placeholder="輸入代號或名稱..."
            style={{ width:'100%', padding:'8px 12px', borderRadius:6, border:'1px solid #2a3a4a', background:'#080d14', color:'#fff', fontSize:13 }}/>
          {results.length > 0 && (
            <div style={{ position:'absolute', top:40, left:0, right:0, background:'#0d1520', border:'1px solid #2a3a4a', borderRadius:8, zIndex:100 }}>
              {results.map(c => (
                <div key={c.ticker} onClick={() => handleAdd(c.ticker, c.name)}
                  style={{ padding:'8px 12px', cursor:'pointer', display:'flex', gap:10, borderBottom:'1px solid #1e2a3a' }}>
                  <span style={{ color:'#4C9BB8', fontWeight:700 }}>{c.ticker}</span>
                  <span style={{ color:'#ccc' }}>{c.name}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* 私房股表格 */}
      <div style={{ background:'#0d1520', border:'1px solid #1e2a3a', borderRadius:8, padding: isMobile ? 10 : 16 }}>
        <div style={{ color:'#7ab0cc', fontSize:13, marginBottom:12, fontWeight:600 }}>
          📋 目前私房股（{watchlist.length}/30）
          {loading && <span style={{ color:'#4a6878', marginLeft:8, fontSize:11 }}>載入中...</span>}
        </div>
        {watchlist.length === 0
          ? <div style={{ color:'#4a6878', padding:'16px 0' }}>尚無個股，請用上方搜尋加入</div>
          : <>
              {isMobile && (
                <div style={{ fontSize: 11, color: '#5a7a92', marginBottom: 6, textAlign: 'center' }}>
                  ← 左右滑動可看更多欄位 →
                </div>
              )}
              <div style={{ overflowX:'auto', overflowY:'auto', maxHeight: isMobile ? 'calc(100vh - 320px)' : 'calc(100vh - 280px)', WebkitOverflowScrolling: 'touch' }}>
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
                <thead>
                  <tr>
                    <th style={thS}>代號／名稱</th>
                    <th style={th}>收盤價</th>
                    <th style={th}>5天漲跌(%)</th>
                    <th style={th}>大戶持股增減(張)</th>
                    <th style={th}>散戶人數增減(人)</th>
                    <th style={th}>月營收年增率(%)</th>
                    <th style={th}>月營收月增率(%)</th>
                    <th style={th}>本季毛利率(%)</th>
                    <th style={th}>毛利率增減(pp)</th>
                    <th style={th}>本季營益率(%)</th>
                    <th style={th}>營益率增減(pp)</th>
                    <th style={th}>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {watchlist.map((s, i) => {
                    const m = summaryMap[s.ticker] || {};
                    const rowBg = i%2===0 ? '#080d14' : '#0a1018';
                    return (
                      <tr key={s.ticker} style={{ background: rowBg }}>
                        <td style={{ ...tdS, background: rowBg }}>
                          <span style={{ color:'#4C9BB8', cursor:'pointer', fontWeight:700 }}
                            onClick={() => setTicker && setTicker(s.ticker)}>{s.ticker}</span>
                          <div style={{ color:'#aaa', fontSize:11 }}>{s.name}</div>
                        </td>
                        <td style={{ ...td, color:'#fff', fontFamily:"'JetBrains Mono',monospace" }}>
                          {m.close ? Number(m.close).toLocaleString() : '-'}
                        </td>
                        <td style={{ ...td, color: clr(m.price_change_5d) }}>
                          {m.price_change_5d != null ? (m.price_change_5d > 0 ? '+' : '') + m.price_change_5d + '%' : '-'}
                        </td>
                        <td style={{ ...td, color: clr(m.big_shares_chg) }}>
                          {fmtN(m.big_shares_chg)}
                        </td>
                        <td style={{ ...td, color: clrRev(m.retail_holders_chg) }}>
                          {fmtN(m.retail_holders_chg)}
                        </td>
                        <td style={{ ...td, color: clr(m.rev_yoy) }}>{fmt(m.rev_yoy)}</td>
                        <td style={{ ...td, color: clr(m.rev_mom) }}>{fmt(m.rev_mom)}</td>
                        <td style={{ ...td, color:'#ccc' }}>{fmt(m.gross_rate)}</td>
                        <td style={{ ...td, color: clr(m.gross_rate_chg) }}>
                          {m.gross_rate_chg != null ? (m.gross_rate_chg>0?'+':'') + m.gross_rate_chg.toFixed(2) : '-'}
                        </td>
                        <td style={{ ...td, color:'#ccc' }}>{fmt(m.op_rate)}</td>
                        <td style={{ ...td, color: clr(m.op_rate_chg) }}>
                          {m.op_rate_chg != null ? (m.op_rate_chg>0?'+':'') + m.op_rate_chg.toFixed(2) : '-'}
                        </td>
                        <td style={td}>
                          <button onClick={() => removeFromWatchlist && removeFromWatchlist(s.ticker)}
                            style={{ padding:'3px 10px', borderRadius:5, border:'1px solid #00a14b', background:'transparent', color:'#00a14b', cursor:'pointer', fontSize:11 }}>
                            移除
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            </>
        }
      </div>
    </div>
  );
}
